var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_3966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34C30.4183 34 34 30.4183 34 26C34 21.5817 30.4183 18 26 18C21.5817 18 18 21.5817 18 26C18 30.4183 21.5817 34 26 34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6535 21.1289C19.0251 21.9465 18.5513 22.8888 18.2754 23.9126H22.4372L19.6535 21.1289Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7242 23.9125C33.4483 22.8888 32.9745 21.9465 32.3461 21.1289L29.5625 23.9125H33.7242Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2754 28.0859C18.5513 29.1096 19.0252 30.052 19.6535 30.8695L22.4371 28.0859H18.2754Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8705 19.6536C30.0529 19.0252 29.1106 18.5513 28.0869 18.2754V22.4372L30.8705 19.6536Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1294 32.3461C21.947 32.9745 22.8893 33.4483 23.913 33.7242V29.5625L21.1294 32.3461Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.913 18.2754C22.8893 18.5513 21.947 19.0252 21.1294 19.6535L23.913 22.4371V18.2754Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0869 33.7242C29.1106 33.4483 30.0529 32.9745 30.8705 32.3461L28.0869 29.5625V33.7242Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 28.0859L32.3461 30.8696C32.9745 30.052 33.4483 29.1096 33.7242 28.0859H29.5625Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9323 24.9565H27.0435H27.0435V18.0677C26.7019 18.0233 26.3537 18 26 18C25.6463 18 25.2981 18.0233 24.9565 18.0677V24.9565V24.9565H18.0677C18.0233 25.2981 18 25.6463 18 26C18 26.3537 18.0233 26.7019 18.0677 27.0435H24.9565H24.9565V33.9323C25.2981 33.9768 25.6463 34 26 34C26.3537 34 26.7019 33.9768 27.0435 33.9323V27.0435V27.0435H33.9323C33.9768 26.7019 34 26.3537 34 26C34 25.6463 33.9768 25.2981 33.9323 24.9565Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0869 28.0879L31.6568 31.6578C31.821 31.4937 31.9776 31.3221 32.127 31.1442L29.0707 28.0879H28.0869V28.0879Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9132 28.0879H23.9131L20.3433 31.6577C20.5074 31.8219 20.679 31.9785 20.8569 32.128L23.9132 29.0716V28.0879Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9132 23.9137V23.9137L20.3433 20.3438C20.1791 20.5079 20.0225 20.6795 19.873 20.8573L22.9294 23.9137H23.9132V23.9137Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0869 23.9132L31.6568 20.3433C31.4927 20.1791 31.3211 20.0225 31.1432 19.873L28.0869 22.9294V23.9132Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_3966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangGb);
export default __webpack_public_path__ + "static/media/lang-GB.2d706804781e294fbec4e4aa31318a2a.svg";
export { ForwardRef as ReactComponent };